import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { I18n } from '@app/i18n/strings-keys';
import {
  IDatepickerConfig,
  IDatepickerValue,
} from '@geniuspos/ui-shared/modules/xdm-shared-components/components/xux-datepicker/types';

@Component({
  selector: 'xvi-xux-datepicker-area',
  template: `
    <div class="xux-datepicker-area" *ngIf="calendarConfig">
      <button
        type="button"
        class="btn datepicker-custom-btn"
        (click)="triggerDatepicker()"
      >
        {{ I18n.Common.SelectDate | translate }}: {{ label }}
      </button>
      <div class="datepicker-hidden-input-wrapper">
        <xux-datepicker-input
          #datepickerInputRef
          [config]="calendarConfig"
          [value]="calendarValue"
          (onChange)="handleDateChange($event)"
        ></xux-datepicker-input>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxDatepickerAreaComponent {
  @Input() public calendarConfig: IDatepickerConfig = null;
  @Input() public calendarValue: IDatepickerValue = null;
  @Input() public label: string = '';

  @Output() public dateChange: EventEmitter<IDatepickerValue> =
    new EventEmitter<IDatepickerValue>();

  @ViewChild('datepickerInputRef', { read: ElementRef })
  private datepickerInputRef: ElementRef;

  public readonly I18n = I18n;

  public triggerDatepicker(): void {
    const iconEl =
      this.datepickerInputRef?.nativeElement?.querySelector('xux-icon');

    if (iconEl) {
      iconEl.click();
    }
  }

  public handleDateChange(value: IDatepickerValue): void {
    this.dateChange.emit(value);
  }
}
